<div class="sidebar" [class.collapsed]="isCollapsed" [class.mobile-open]="isMobileOpen">
 <!-- Inner glass panel (spec §4): the .sidebar is the padded container that
      detaches the panel from the window edges; this wrapper carries the glass
      surface (bg / radius / blur / elevation). -->
 <div class="sidebar-panel">

  <!-- Logo / toggle -->
  <div class="sidebar-logo">
    <!-- Brand tile (spec §4): 40px orange tile + "NGX Hub / Financial" -->
    <div class="sidebar-brand-tile" aria-hidden="true">NGX</div>
    <div class="sidebar-brand-text">
      <span class="sidebar-brand-title">NGX Hub</span>
      <span class="sidebar-brand-sub">Financial</span>
    </div>

    <!-- Desktop colapsado: tile vira botão de expandir -->
    <button class="logo-mark-btn desktop-only" (click)="toggleCollapse()" matTooltip="Expandir menu" matTooltipPosition="right">
      <span class="sidebar-brand-tile" aria-hidden="true">NGX</span>
    </button>

    <!-- Desktop expandido: botão de recolher -->
    <button class="collapse-btn desktop-only" (click)="toggleCollapse()" matTooltip="Recolher menu" matTooltipPosition="right">
      <mat-icon>chevron_left</mat-icon>
    </button>
  </div>

  <!-- ── MODO EXPANDIDO ─────────────────────────────────── -->
  <nav class="sidebar-nav" *ngIf="!isCollapsed || isMobileOpen">
    <!-- Section label for the top-level items (spec §4): static, non-collapsible
         header that reuses the group-header micro-label type so Dashboard/Reports
         read as a titled section, consistent with the other nav groups. -->
    <div class="nav-group-header nav-section-label" *ngIf="hasVisibleNavItems">
      <div class="nav-group-header-left">
        <span>{{ 'sidebar.principal' | translate }}</span>
      </div>
    </div>

    <ng-container *ngFor="let item of navItems">
      <a
        *ngIf="isVisible(item)"
        [routerLink]="item.route"
        class="nav-item"
        [class.active]="isActive(item.route)"
      >
        <mat-icon>{{ item.icon }}</mat-icon>
        <span>{{ item.label | translate }}</span>
      </a>
    </ng-container>

    <ng-container *ngFor="let group of navGroups">
      <div class="nav-group" *ngIf="isGroupVisible(group)">
        <button class="nav-group-header" (click)="toggleGroup(group)" [class.active]="!group.collapsed">
          <div class="nav-group-header-left">
            <mat-icon>{{ group.icon }}</mat-icon>
            <span>{{ group.label | translate }}</span>
          </div>
          <mat-icon class="chevron" [class.expanded]="!group.collapsed">chevron_right</mat-icon>
        </button>

        <div class="nav-group-items" [class.open]="!group.collapsed">
          <ng-container *ngFor="let item of group.items">
            <a
              *ngIf="isVisible(item)"
              [routerLink]="item.route"
              class="nav-item nav-item-child"
              [class.active]="isActive(item.route)"
            >
              <mat-icon>{{ item.icon }}</mat-icon>
              <span>{{ item.label | translate }}</span>
            </a>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </nav>

  <!-- ── MODO MINI (só ícones) ─────────────────────────── -->
  <nav class="sidebar-nav-mini" *ngIf="isCollapsed && !isMobileOpen">
    <ng-container *ngFor="let item of allItems">
      <a
        *ngIf="isVisible(item)"
        [routerLink]="item.route"
        class="mini-item"
        [class.active]="isActive(item.route)"
        [matTooltip]="item.label | translate"
        matTooltipPosition="right"
      >
        <mat-icon>{{ item.icon }}</mat-icon>
      </a>
    </ng-container>
  </nav>

  <div class="sidebar-footer">
    <div class="version" *ngIf="!isCollapsed">v{{ appVersion }}</div>
  </div>
 </div>
</div>
